import React, { Fragment } from "react";
import styled from "styled-components";
import moment from "moment";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const StyledDateDiv = styled.div`
  color: rgb(0, 0, 0, 0.537);
  font-size: 17px;
`;

const styles = theme => ({
  icon: {
    color: "#2196f3",
    cursor: "pointer",
    transition: "0.3s",
    "&:hover": {
      color: "#9e9e9e"
    }
  }
});

const StyledSubject = styled.div`
  font-weight: bold;
`;

const Spacer = styled.div`
  flex-grow: 1;
`;

const NotificationItem = ({ notification }) => {
  const currentValue = notification.currentValue;
  const dateAndCurrentValueString = currentValue ? `${moment.utc(notification.dateSent).format("MM/DD/YYYY")} | ${currentValue}` : moment.utc(notification.dateSent).format("MM/DD/YYYY");

  return (
    <Grid direction="row">
      <StyledSubject>{notification.formattedSubject}</StyledSubject>
      <StyledDateDiv>
        {dateAndCurrentValueString}
      </StyledDateDiv>
      <div>{notification.formattedMessage}</div>
      <Spacer />
    </Grid>
  );
};
export default withStyles(styles)(NotificationItem);
